export function saveToLocalStorage(key: string, data: any) {
  if (typeof window !== "undefined") {
    try {
      const serializedData = JSON.stringify(data)
      localStorage.setItem(key, serializedData)
    } catch (error) {
      console.error("ローカルストレージへの保存に失敗しました:", error)
    }
  }
}

export function loadFromLocalStorage(key: string) {
  if (typeof window !== "undefined") {
    try {
      const serializedData = localStorage.getItem(key)
      if (serializedData === null) {
        return undefined
      }
      return JSON.parse(serializedData)
    } catch (error) {
      console.error("ローカルストレージからの読み込みに失敗しました:", error)
      return undefined
    }
  }
  return undefined
}

export function removeFromLocalStorage(key: string) {
  if (typeof window !== "undefined") {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error("ローカルストレージからの削除に失敗しました:", error)
    }
  }
}
